import { useEffect, useMemo } from "react";

import { isDesktopHostedConnectionTarget } from "~/connection/desktopLocal";
import { useClientSettings } from "~/hooks/useSettings";
import { useEnvironments } from "~/state/environments";
import { useThreadShells } from "~/state/entities";
import { shouldPreventDesktopSleep } from "./DesktopPowerSaveBlockerSync.logic";

function setPreventSleep(enabled: boolean): void {
  const update = window.desktopBridge?.setPreventSleep;
  if (update === undefined) return;

  void update(enabled).catch((cause) => {
    console.error("Could not update desktop sleep prevention.", cause);
  });
}

function DesktopPowerSaveBlockerController() {
  const enabled = useClientSettings((settings) => settings.preventSleepWhileRunning);
  const { environments } = useEnvironments();
  const threads = useThreadShells();

  const localEnvironmentIds = useMemo(
    () =>
      new Set(
        environments
          .filter((environment) => isDesktopHostedConnectionTarget(environment.entry.target))
          .map((environment) => environment.environmentId),
      ),
    [environments],
  );
  const shouldPreventSleep = shouldPreventDesktopSleep({
    enabled,
    localEnvironmentIds,
    threads,
  });

  useEffect(() => {
    setPreventSleep(shouldPreventSleep);
  }, [shouldPreventSleep]);

  useEffect(
    () => () => {
      setPreventSleep(false);
    },
    [],
  );

  return null;
}

export function DesktopPowerSaveBlockerSync() {
  return window.desktopBridge?.setPreventSleep === undefined ? null : (
    <DesktopPowerSaveBlockerController />
  );
}
